import { useLayoutEffect, useState } from "react";

export const APP_HEADER_ID = "app-header";
export const BOTTOM_NAV_ID = "app-bottom-nav";

export default function useAvailableHeight(ref) {
  const [height, setHeight] = useState(null);

  useLayoutEffect(() => {
    const update = () => {
      const el = ref.current;
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY;
      const nav = document.getElementById(BOTTOM_NAV_ID);
      const navHeight = nav ? nav.getBoundingClientRect().height : 0;
      setHeight(Math.max(Math.floor(window.innerHeight - top - navHeight), 0));
    };

    update();

    const observer = new ResizeObserver(update);
    [APP_HEADER_ID, BOTTOM_NAV_ID].forEach((id) => {
      const target = document.getElementById(id);
      if (target) observer.observe(target);
    });
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, [ref]);

  return height;
}
